/** When your routing table is too long, you can split it into small modules */

const authRouter = [
    {
      path: '/signin',
      alias: '/login',
      component: () => import('@/views/auth/SignIn.vue'),
      hidden: true,
    },
    {
      path: "/forgotpassword",
    name: "forgotpassword",
      component: () => import("@/views/auth/ForgotPassword/index.vue"),
      hidden: true
    },
    {
      path: "/resetpassword",
      alias: "/reset",
      component: () => import("@/views/auth/ResetPassword/index.vue"),
      hidden: true
    }
  ];
  
  export default authRouter;
  